/* ============================================================
   SOCIAL IRONY — auth.js
   Password recovery panel toggle, customer address forms, newsletter UX.
   Everything degrades to server-rendered forms without JS.
   ============================================================ */

(function () {
  'use strict';

  const qs = window.SI.qs;
  const qsa = window.SI.qsa;

  /* ---------- Password recovery toggle ---------- */
  const recoverToggle = qs('[data-si-recover-toggle]');
  const recoverForm = qs('[data-si-recover-form]');

  if (recoverToggle && recoverForm) {
    recoverToggle.addEventListener('click', () => {
      recoverForm.hidden = !recoverForm.hidden;
      if (!recoverForm.hidden) {
        const input = recoverForm.querySelector('input[type="email"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Address forms ---------- */
  const addressToggle = qs('[data-si-address-toggle]');
  const addressForm = qs('[data-si-address-form]');

  if (addressToggle && addressForm) {
    addressToggle.addEventListener('click', () => {
      addressForm.hidden = !addressForm.hidden;
      addressToggle.setAttribute('aria-expanded', addressForm.hidden ? 'false' : 'true');
    });
  }

  qsa('[data-si-address-edit]').forEach((button) => {
    button.addEventListener('click', () => {
      const id = button.dataset.siAddressEdit;
      const form = qs('[data-si-address-form-' + id + ']');
      if (form) {
        form.hidden = !form.hidden;
        if (!form.hidden) form.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });
  });

  /* ---------- Set default address: submit the hidden form ---------- */
  qsa('[data-si-address-default]').forEach((button) => {
    button.addEventListener('click', () => {
      const id = button.dataset.siAddressDefault;
      const form = qs('[data-si-set-default-' + id + ']');
      if (form) form.submit();
    });
  });

  /* ---------- Delete address confirmation ---------- */
  qsa('[data-si-address-delete]').forEach((button) => {
    button.addEventListener('click', (event) => {
      if (!window.confirm('Delete this address?')) {
        event.preventDefault();
      }
    });
  });
})();
